import script from "./teacher-superiority.vue?vue&type=script&setup=true&lang=js"
export * from "./teacher-superiority.vue?vue&type=script&setup=true&lang=js"

import "./teacher-superiority.vue?vue&type=style&index=0&id=5d366e26&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d366e26"]])

export default __exports__